import React from 'react';
import { Box, Drawer, List, Typography } from '@mui/material';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import { MobileNavigationItemWrapper } from '../../../MainFrame/Header/MobileView/MobileNavigationItemWrapper';
import {
    SIDEBAR_ADMIN_NAVIGATION,
    SIDEBAR_PROFILE_NAVIGATION,
} from '../../../../../utils/constans/SidebarMenu';
import useUserSWR from '../../../../../hooks/user/useUserSWR';

export const ProfileMobileDrawer = () => {
    const mobileMenu = useMobileMenu();
    const { user } = useUserSWR();

    const toggleDrawer =
        (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            mobileMenu.showProfileMenu(open);
        };

    return (
        <>
            <Drawer
                anchor={'right'}
                open={mobileMenu.mobileMenuStates.profile.open}
                onClose={toggleDrawer(false)}
            >
                <MobileNavigationItemWrapper
                    menuItems={SIDEBAR_PROFILE_NAVIGATION}
                />
                {user && user.is_admin && (
                    <>
                        <Box sx={{ width: 250, paddingX: '10px' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                Admin menu
                            </Typography>
                        </Box>
                        <MobileNavigationItemWrapper
                            menuItems={SIDEBAR_ADMIN_NAVIGATION}
                        />
                    </>
                )}
            </Drawer>
        </>
    );
};
